import querystring from "querystring";
import { useLocation } from "react-router-dom";

export const useQueryParams = () => {
  // Slice the leading ? character from the search string
  const queryStr = useLocation().search.slice(1);
  return querystring.parse(queryStr);
};

export const getWindowRelativeUrl = (url: string) => {
  const parsedUrl = new URL(url);
  return parsedUrl.toString().replace(parsedUrl.origin, window.location.origin);
};

export const isThomasnetDomain = () => {
  return /\.thomasnet\.com/.test(window.location.host);
};
